import React, { useContext, useEffect, useCallback, useMemo, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { useHistory } from 'react-router-dom'

import Row, { RowBetween } from '../../components/Row'
import SortPets from '../Pet/components/SortPets'
import Search from '../Restaurant/components/Search'
import Loading from '../../components/Loader/Loading'
import NoArtwork from '../../components/Collection/NoArtwork'
import InfiniteScroll from '../../components/view/InfiniteScroll'
import ArtworkCard from '../../components/Collection/ArtworkCard'
import { ButtonConfirmed } from '../../components/Button'

import { useActiveWeb3React } from '../../hooks'
import { getArtworksV3, getArtworks, getArtworksV2 } from '../../service/nft'
import { SortOptions, TabOptions, AuctionBake, MAXSCROLLNUM } from '../../constants/artwork'
import { getSummary } from '../../service/bakery'
import { memeList } from '../../constants/nft'

const Wapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 0px;
    text-align: center;
  `}
`
const ExploreWrapper = styled.div`
  max-width: 1184px;
  margin: 0 auto;
  position: relative;
  padding-left: 25px;
  padding-right: 25px;
`
const ArtworkList = styled.div`
  margin-top: 30px;
  display: grid;
  grid-row-gap: 20px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 272px);
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`
const BtnRow = styled.div`
  display: flex;
`
const CreatedBtn = styled(ButtonConfirmed)`
  color: ${({theme}) => theme.white};
  font-family: 'Roboto-Bold';
  padding: 0;
  border: none;
  font-size: 14px;
  width: 172px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  align-self: flex-start;
  background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
  border-radius: 35px;
  margin-right: 8px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-self: center; 
  `}
`
const Title = styled(RowBetween)`
  font-size: 40px;
  padding-top: 24px;
  padding-bottom: 8px;
  color: ${({ theme }) => theme.bsText22};
  font-family: 'Roboto-Bold';
  flex-wrap: wrap;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    justify-content: center;
  `}
` 
const LevelRow = styled(Row)`
  flex-direction: row-reverse;
  justify-content: flex-end;
  padding-top: 30px;
  padding-bottom: 5px;
  margin-left: -30px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    position: static;
    justify-content: center;
    padding-top: 50px;
  `}
`
const activeLevel = 'ACTIVELEVEL'
const LevelText = styled(Text).attrs({activeLevel})`
  position: relative;
  width: 92px;
  font-family: 'Roboto-Bold';
  font-size: 22px;
  text-align: center;
  border-right: 1px solid rgba(177, 177, 177, 0.41);
  cursor: pointer;
  &.${activeLevel} {
    background: linear-gradient(to right, #FFD600, #FF7A00);
    -webkit-background-clip: text;
    color: transparent;
  }
  &:first-child {
    border: none;
  }
  img{
    position: absolute;
    right: 0;
    top: -15px;
  }
`
const MyArtworkBtn = styled.button`
  width: 148px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(to right, #FFD600, #FF7A00);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 14px;
  border-radius: 50px;
  border: 1px solid #FF7A00;
  font-family: 'Roboto-Bold';
  cursor: pointer;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: 15px 0;
  `}
`

const Limit = 20
export default function Explore () {
  const theme = useContext(ThemeContext)
  const history = useHistory()
  const { account, chainId } = useActiveWeb3React()

  const [curValue, setCurValue] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [curTab, setCurTab] = useState(TabOptions[0])
  const [curSelect, setCurSelect] = useState(SortOptions[0])
  const emptyArtworks: any[] = []
  const [artworkList, setArtworkList] = useState(emptyArtworks)
  const [loading, setLoading] = useState(false)
  const [loadedAll, setLoadedAll] = useState(false)
  const [summary, setSummary] = useState({
    priceUSD: '',
    circulationMarketCap: '',
    circulation: '',
    burned: '',
    totalLiquidityUSD: '',
    volume24hUSD: '',
    totalNft: '',
    totalNftTransaction: '',
    totalNftVolumeBAKE: '',
    totalNftLockedBAKE: '',
    totalSupply: ''
  })

  const level = ['v1', 'v2', 'v3']
  const [avtiveLevel, setActiveLevel] = useState(level[2])

  const memeNFTtypes = useMemo(() => {
    const arr = memeList.map((d) => d.nftType).join(',')
    return arr
  }, [memeList])

  const params = useMemo(() => {
    return {
      nftTypes: memeNFTtypes,
      limit: Limit,
      onSale: 1,
      sortBy: curSelect.sortBy,
      sortName: curSelect.sortName,
      fileType: +curTab.sortName ? +curTab.sortName : '',
      keyword: searchValue.trim(),
      status: 1
    }
  }, [searchValue, curSelect, curTab])

  const getData = useMemo(() => {
    let methods
    switch (avtiveLevel) {
      case level[0]:
        methods = getArtworks
        break;
      case level[1]:
        methods = getArtworksV2
        break;
      case level[2]:
        methods = getArtworksV3
        break;
      default:
        methods = getArtworksV3
        break;
    }
    return methods
  }, [avtiveLevel, level])

  const fetchList = useCallback(() => {
    getData(chainId as number, {
      ...params,
      offset: artworkList.length,
    }, (err: any, data: any) => {
      setLoading(false)
      if (err) return
      if (data.code !== 0) return
      const dataAry = data.data.list || []
      const artworks = dataAry.map((d: any) => {
        return {
          ...d,
          tokenId: d.nftId || d.id,
          status: d.status || 1,
          nftLevel: avtiveLevel,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })
      const newList = [...artworkList, ...artworks]
      setArtworkList(newList)
      if (newList.length >= data.data.count || newList.length > MAXSCROLLNUM) {
        setLoadedAll(true)
      }
    })
  }, [chainId, params, artworkList, getData, avtiveLevel, account])

  const inputChange = useCallback((e: any) => {
    setCurValue(e.target.value)
  }, [])
  const searchHandle = (value: string) => {
    setSearchValue(value)
  }
  const updateData = useCallback((d) => {
    setCurSelect(d)
  }, [])
  const upTab = useCallback((d) => {
    setCurTab(d)
  }, [])
  const loadmore = useCallback(() => {
    setLoading(true)
  }, [])

  const goMint = useCallback(() => {
    history.push(`/mint-newArtworks/111,3`)
  }, [])

  const goMyArtwork = useCallback(() => {
    history.push(`/usercenter/${account}?type=CREATED`)
  }, [account])

  // Init List
  useEffect(() => {
    setLoadedAll(false)
    setLoading(true)
    setArtworkList([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, chainId, getData])

  useEffect(() => {
    if (!loading) return
    fetchList()
  }, [loading])

  useEffect(() => {
    getSummary(chainId as number, (err: any, d: any) => {
      if (err) return
      if (d.code !== 0) return
      setSummary(d.data)
    })
  }, [chainId])

  return (
    <>
      <Loading open={loading} />
      <Wapper>
        <ExploreWrapper>
          <Title>
            <Text fontSize={40} color={theme.bsText22} fontFamily={'Roboto-Bold'}>Explore</Text>
            <BtnRow>
              <CreatedBtn onClick={goMint}>Create</CreatedBtn>
              <MyArtworkBtn onClick={goMyArtwork}>My Artworks</MyArtworkBtn>
            </BtnRow>
          </Title>
          <Text color={theme.bsText22}>A market made for NFT, where everything is special 😋</Text>
          <LevelRow>
            {
              level.map((d, i) => {
                return (
                  <LevelText key={i} className={avtiveLevel === d ? activeLevel : ''} onClick={() => setActiveLevel(d)}>
                    {d === 'v3' && <img src="/images/collection/icon_new.svg" alt=""/>}
                    {d.toLocaleUpperCase()}
                  </LevelText>
                )
              })
            }
          </LevelRow>
          <Row justifyContent='flex-end' marginTop={'34px'}>
            <Search value={curValue} inputChange={inputChange} searchHandle={searchHandle}></Search>
            <SortPets
              bg={theme.bsBg30}
              height={32}
              margin="0 15"
              curSelect={curTab}
              options={TabOptions}
              updateData={upTab}
            ></SortPets>
            <SortPets
              wd='110px'
              height={32}
              bg={theme.bsBg30}
              curSelect={curSelect}
              options={SortOptions}
              updateData={updateData}
            ></SortPets>
          </Row>
          <Row marginTop={'-10px'} marginBottom={'24px'}>
            <Text fontSize={16} color={theme.text6} fontFamily={'Roboto-Bold'} marginRight={'6px'}>{ summary.totalNft ? new BigNumber(summary.totalNft).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) : 0 }</Text>
            <Text fontSize={16} color={theme.bsBg11} fontFamily={'Roboto-Bold'}> Items</Text>
          </Row>
          {
            artworkList.length ?
              <InfiniteScroll loading={loading} loadedAll={loadedAll} loadmore={loadmore}>
                <ArtworkList>
                  {
                    artworkList.map((d) => {
                      return (
                        <ArtworkCard key={d.id} artwork={d}></ArtworkCard>
                      )
                    })
                  }
                </ArtworkList>
              </InfiniteScroll>
            : !loading && <NoArtwork></NoArtwork>
          }
        </ExploreWrapper>
      </Wapper>

    </>
  )
}